import { Atom } from 'AppReact';
import styled, { css } from 'styled-components';

const template = styled.div`
  ${({ theme }) => css`
    display: none;
    font-weight: 600;
    font-size: 12px;
    white-space: nowrap;
    margin-right: 6px;
    color: ${theme?.colour?.secondary ?? "#04333b"};
    
    @media only screen and (min-width: 768px) {
      display: unset;
    }
  `}
`;

export default Atom({ type: 'label', dataType: 'string', template })